<template>
  <b-modal
    size="lg"
    title="Nuevos recursos"
    id="modal-upload-files"
    class="cme-modal"
    ref="modalUploadFiles"
    no-close-on-backdrop
    hide-header-close
    @shown="activeUppy"
  >
    <div class="DashboardContainer"></div>
    <div>
      <vue-tags-input
        v-model="tag"
        :tags="tags"
        :placeholder="placeholderTags"
        @tags-changed="newTags => tags = newTags"
      />
    </div>
    <div slot="modal-footer">
      <b-spinner
        v-if="isLoading"
        variant="primary"
        label="Spinning"
        style="vertical-align: middle; margin-right:20px;"
      ></b-spinner>
      <b-button v-if="!isLoading" variant="primary" class="mr-2" @click="saveRecursos">Guardar</b-button>
      <b-button @click="close">Cancelar</b-button>
    </div>
  </b-modal>
</template>

<script>
// Uppy section
import * as Uppy from "@uppy/core";
import * as Dashboard from "@uppy/dashboard";
//import * as Tus from "@uppy/tus";
import * as AwsS3 from "@uppy/aws-s3";
import * as Spanish from "@uppy/locales/lib/es_ES";
import { uuid } from "uuidv4";

import VueTagsInput from "@johmun/vue-tags-input";
import RecursoService from "@/services/recurso.service";

export default {
  name: "modal-upload-files",
  components: {
    VueTagsInput
  },
  data() {
    return {
      placeholderTags: "Agrega etiquetas",
      tag: "",
      tags: [],
      user: this.$store.getters["auth/infoUser"],
      files: [],
      isLoading: false
    };
  },
  methods: {
    activeUppy() {
      console.log("modal activado");
      var uppy = Uppy({
        id: "uppyLoadFiles",
        debug: true,
        autoProceed: false,
        locale: Spanish,
        restrictions: {
          allowedFileTypes: ["image/*", "video/*", "audio/*"]
        },
        onBeforeFileAdded: (currentFile, files) => {
          var ext = currentFile.type.split("/")[1];
          const modifiedFile = Object.assign({}, currentFile, {
            name: uuid() + "." + ext
          });
          return modifiedFile;
        }
      });
      uppy
        .use(Dashboard, {
          trigger: ".UppyModalOpenerBtn",
          inline: true,
          target: ".DashboardContainer",
          replaceTargetContent: true,
          note: null,
          maxHeight: 450,
          proudlyDisplayPoweredByUppy: false
        })
        .use(AwsS3, {
          target: Dashboard,
          companionUrl: `${process.env.VUE_APP_API_URL}/companion`
        })
        /*.use(Tus, {
          endpoint: `${process.env.VUE_APP_API_URL}/uploader`,
          //endpoint: 'https://nyc3.digitaloceanspaces.com',
          resume: true,
          autoRetry: true
        })*/
        .on("file-added", file => {
          console.log("Added File:", file);
        })
        .on("upload-error", (file, error, response) => {
          console.log("error with file:", file);
        })
        .on("complete", result => {
          // obtener todos los files agregados para guardar en la base de datos
          if (result.successful.length > 0) {
            result.successful.forEach(el => {
              this.files.push(el);
            });
          }
        });
    },
    close() {
      this.$bvModal.hide("modal-upload-files");
      this.tags = [];
    },
    saveRecursos() {
      /*this.$root.triggetSuccessMgs("Datos guardados con éxito", "");
      this.$emit("onSuccessFiles");
      this.close();
      this.isLoading = false;*/
      var totalFiles = this.files.length;
      var tags = [];
      var resolversTotal = 0;

      if (this.tags.length > 0) {
        this.tags.forEach(el => {
          tags.push(el.text);
        });
      }

      if (totalFiles > 0 && tags.length > 0) {
        this.isLoading = true;
        this.files.forEach(el => {
          var uploadURL = el.uploadURL;
          //var fileId = uploadURL.split("/").pop();
          var fileId = el.name;
          var fileType = el.type.split("/")[0];
          var type = "IMAGEN";
          switch (fileType) {
            case "image":
              type = "IMAGEN";
              break;
            case "video":
              type = "VIDEO";
              break;
            case "audio":
              type = "AUDIO";
              break;
          }
          // por cada file se arma su data para guardar en la BD
          var newData = {
            nombre: el.name,
            file: fileId,
            categorias: [],
            compartido: [],
            tags: tags,
            author: this.user._id,
            visibilidad: "PUBLICO", // default
            type: type
          };

          RecursoService.save(newData).then(result => {
            resolversTotal++;
            if (resolversTotal == totalFiles) {
              setTimeout(() => {
                this.$root.triggetSuccessMgs("Datos guardados con éxito", "");
                this.$emit("onSuccessFiles");
                this.close();
                this.isLoading = false;
              }, 1000);
            }
          });
        });
      } else {
        this.$root.triggerWarnMgs(
          "Completa la información para guardar los recursos",
          ""
        );
      }
    }
  }
};
</script>

<style lang="scss">
.ti-tag {
  background-color: #20a8d8 !important;
}
.vue-tags-input {
  max-width: 100% !important;
  width: 100%;
}
.uppy-size--md .uppy-Dashboard-inner {
  margin: 7px;
}
</style>